/**
 * Build request body for paginated grid endpoints (POST grid).
 */
export function buildPaginationBody(config: {
  pageNumber: number;
  pageSize: number;
  searchTerm?: string;
  filter?: unknown;
  sortField?: string;
  sortOrder?: 1 | -1 | null;
}): Record<string, unknown> {
  return {
    pageNumber: config.pageNumber,
    pageSize: config.pageSize,
    searchTerm: config.searchTerm,
    filter: config.filter,
    sortField: config.sortField || undefined,
    sortDirection: config.sortOrder === 1 ? 'asc' : config.sortOrder === -1 ? 'desc' : undefined,
  };
}
